<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';

import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import EvolutionAPI from 'dashboard/api/evolution';
import InboxEvolutionAPI from 'dashboard/api/inbox/evolution';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      baseUrl: '',
      apiKey: '',
      isConnecting: false,
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    baseUrl: { required },
    apiKey: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid || this.isConnecting) {
        return;
      }

      this.isConnecting = true;
      let createdInbox = null;

      try {
        await EvolutionAPI.updateConfig({
          base_url: this.baseUrl.trim(),
          api_key: this.apiKey.trim(),
        });

        createdInbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'whatsapp',
            phone_number: this.phoneNumber,
            provider: 'evolution',
            provider_config: {},
          },
        });

        await InboxEvolutionAPI.connect(createdInbox.id);
        await this.$store.dispatch('inboxes/get');

        router.replace({
          name: 'settings_inbox_finish',
          params: {
            page: 'new',
            inbox_id: createdInbox.id,
          },
        });
      } catch (error) {
        if (createdInbox?.id) {
          await this.$store.dispatch('inboxes/get');
        }
        useAlert(error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE'));
      } finally {
        this.isConnecting = false;
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.baseUrl.$error }">
        <span>{{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_BASE_URL.LABEL') }}</span>
        <input
          v-model="baseUrl"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_BASE_URL.PLACEHOLDER')"
          @blur="v$.baseUrl.$touch"
        />
        <span v-if="v$.baseUrl.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_BASE_URL.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiKey.$error }">
        <span>{{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_API_KEY.LABEL') }}</span>
        <input
          v-model="apiKey"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_API_KEY.PLACEHOLDER')"
          @blur="v$.apiKey.$touch"
        />
        <span v-if="v$.apiKey.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_API_KEY.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating || isConnecting"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION_SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
